module.exports = __webpack_public_path__ + "media/images/certo-4b2c0ef5a9debaa16eb45d48c3aab1ba.svg";